/* pringbud-muslim-boys-menu-link */
(function() {
  var href = "/collections/boys-thobes";
  var collection = { id: "435296633065", handle: "boys-thobes", title: "BOY'S THOBES", image: null };
  function norm(s) { return (s || "").replace(/\s+/g, " ").trim().toLowerCase(); }
  function setNode(node) {
    node.setting = node.setting || {};
    node.setting.url = { type: { id: "collection", icon: ["fas", "columns"], name: "Collection" }, collection: JSON.parse(JSON.stringify(collection)) };
    node.setting.disable_link = false;
  }
  function walk(node, parent) {
    if (!node || typeof node !== "object") return;
    var title = node.setting && node.setting.title || "";
    if (node.id === "tmenu-menu-899187" || (norm(parent) === "muslim clothing" && norm(title) === "boys")) setNode(node);
    if (Array.isArray(node.menus)) node.menus.forEach(function(child) { walk(child, title || parent); });
    var mega = node.data && node.data.data && node.data.data.megamenu;
    if (Array.isArray(mega)) mega.forEach(function(child) { walk(child, title || parent); });
  }
  function patchConfig() {
    if (!window._SM || !window._SM.newEntries) return;
    Object.keys(window._SM.newEntries).forEach(function(key) { walk(window._SM.newEntries[key], ""); });
  }
  function patchRendered() {
    document.querySelectorAll("[id='tmenu-menu-899187'],[data-id='tmenu-menu-899187']").forEach(function(holder) {
      var a = holder.tagName === "A" ? holder : holder.querySelector("a");
      if (a) { a.setAttribute("href", href); a.removeAttribute("target"); }
    });
    Array.prototype.forEach.call(document.querySelectorAll("a"), function(a) {
      if (norm(a.textContent) !== "boys") return;
      var el = a.parentElement;
      for (var i = 0; el && i < 8; i += 1, el = el.parentElement) {
        if (norm(el.textContent).indexOf("muslim clothing") === 0) { a.setAttribute("href", href); a.removeAttribute("target"); break; }
      }
    });
  }
  function apply() { patchConfig(); patchRendered(); }
  apply(); document.addEventListener("DOMContentLoaded", apply); window.addEventListener("load", apply);
  var count = 0, timer = window.setInterval(function() { apply(); if (++count > 100) window.clearInterval(timer); }, 250);
  new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });
})();
